import { render, staticRenderFns } from "./LineClassDaySale.vue?vue&type=template&id=15366dd8&scoped=true"
import script from "./LineClassDaySale.vue?vue&type=script&lang=js"
export * from "./LineClassDaySale.vue?vue&type=script&lang=js"
import style0 from "./LineClassDaySale.vue?vue&type=style&index=0&id=15366dd8&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15366dd8",
  null
  
)

export default component.exports